export const NUMBER_OF_BOXES = {
  X: 9,
  Y: 9
};

export const GestureIdleTimeInMs = 200;

export const MAX_PATH_LENGTH = 6;
